import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Animate from './Animate';

var Notice = /*#__PURE__*/function (_Component) {
  _inherits(Notice, _Component);

  var _super = _createSuper(Notice);

  function Notice() {
    var _this;

    _classCallCheck(this, Notice);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "closeTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      fadeIn: true
    });

    _defineProperty(_assertThisInitialized(_this), "closeHandel", function (e) {
      if (e) {
        e.stopPropagation();
      }

      _this.setState(function (state) {
        return {
          fadeIn: !state.fadeIn
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      var _this$props$onClose, _this$props;

      _this.clearCloseTimer();

      (_this$props$onClose = (_this$props = _this.props).onClose) === null || _this$props$onClose === void 0 ? void 0 : _this$props$onClose.call(_this$props);
    });

    _defineProperty(_assertThisInitialized(_this), "startCloseTimer", function () {
      if (_this.props.duration) {
        _this.closeTimer = window.setTimeout(function () {
          _this.closeHandel();
        }, _this.props.duration * 1000);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearCloseTimer", function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    });

    return _this;
  }

  _createClass(Notice, [{
    key: "componentDidMount",
    value: // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    function componentDidMount() {
      this.startCloseTimer();
    } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.duration !== prevProps.duration || this.props.update) {
        this.restartCloseTimer();
      }
    } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: "restartCloseTimer",
    value: function restartCloseTimer() {
      this.clearCloseTimer();
      this.startCloseTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var componentClass = "".concat(props.prefixCls, "-notice");
      return /*#__PURE__*/React.createElement(Animate, {
        fadeIn: this.state.fadeIn,
        onExited: this.close,
        className: "".concat(componentClass)
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(componentClass, " "),
        style: props.style,
        onMouseEnter: this.clearCloseTimer,
        onMouseLeave: this.startCloseTimer
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(componentClass, "-content")
      }, props.children), /*#__PURE__*/React.createElement("span", {
        tabIndex: 0,
        onClick: this.closeHandel,
        className: "".concat(componentClass, "-close")
      }, props.closeIcon)));
    }
  }]);

  return Notice;
}(Component);

export { Notice as default };